import { CONFIG } from "../../config";
import { getTokenizedAxios } from "../../utils/axiosWithTokenGen";
import {
  IProvisionSandboxPartnerInput,
  IProvisionSandboxPartnerResult,
} from "./partnersSandbox.types";

export async function provisionSandboxPartner(
  input: IProvisionSandboxPartnerInput
): Promise<IProvisionSandboxPartnerResult> {
  const axios = await getTokenizedAxios();
  const path = "/partners/sandbox/provision";

  return axios
    .post(CONFIG.ADMIN_SERVER.BASE_URL + path, input)
    .then((data) => data?.data);
}
